<template>
    <div class="media align-items-center mb-7">
        <div class="u-lg-avatar mr-3">
            <img class="img-fluid rounded-circle" :src="avatarDisplayUrl" alt="Image Description">
        </div>
        <p v-if="error" class="text-danger">{{ error }}</p>

        <form v-if="haveAvatar" @submit="delete_avatar" class="media-body">
            <LoadingButton v-if="isRequestLoading"/>
            <button v-else type="submit" class="btn btn-sm btn-soft-secondary transition-3d-hover mb-1 mb-sm-0">Supprimer</button>
        </form>

        <form v-else @submit="upload_avatar">
            <div class="js-form-message form-group mb-3">
                <input ref="avatar" type="file" accept="image/*" class="form-control btn btn-sm btn-soft-primary">
            </div>
            <LoadingButton v-if="isRequestLoading"/>
            <button v-else type="submit" class="btn btn-sm btn-soft-secondary transition-3d-hover mb-1 mb-sm-0">Appliquer</button>
        </form>
    </div>
</template>

<script>
    import {mapMutations} from "vuex";
    import LoadingButton from "./LoadingButton";
    import {ASSETS_FOLDER, UPLOAD_FILES_ENDPOINT} from "../settings";
    import {DELETE_AVATAR, UPDATE_AVATAR} from "../settings/graphql";
    import {errorMessageDisplay} from "../xlib/graphql";

    export default {
        name: "UpdateAvatarForm",
        components: {LoadingButton},
        data() {
            return {
                isRequestLoading: false,
                error: "",
            };
        },
        computed: {
            avatarUrl: function() {
              return this.$store.state.user.info.profile.avatarUrl;
            },
            haveAvatar: function () {
              return !!this.avatarUrl;
            },
            avatarDisplayUrl: function () {
                return this.avatarUrl ? this.avatarUrl : `${ASSETS_FOLDER}/img/160x160/anonymous_user.png`
            }
        },
        methods: {
            ...mapMutations([
                'setUserAvatar'
            ]),
            storeUserAvatar(avatarUrl) {
                this.setUserAvatar(avatarUrl);
            },
            deleteUserAvatarStore() {
                this.storeUserAvatar(null);
            },
            upload_avatar: function (event) {
                event.preventDefault();
                this.$data.isRequestLoading = true;

                let formData = new FormData();
                formData.append('image', this.$refs.avatar.files[0]);

                const self = this;

                this.axios.post(UPLOAD_FILES_ENDPOINT,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function(response) {
                    const avatarUrl = response.data['image'];
                    // console.log(`Image uploaded successfully: ${avatarUrl}`);

                    self.$apollo.mutate({
                        mutation: UPDATE_AVATAR,
                        variables: {avatarUrl}
                    }).then(() => {
                        // console.log(`Avatar successfully updated`);
                        self.$data.avatarUrl = avatarUrl;
                        self.$data.haveAvatar = !!avatarUrl;
                        self.storeUserAvatar(avatarUrl);
                        self.$data.isRequestLoading = false;
                    }).catch((error) => {
                        // console.error(`Error ${error} on avatar uploading`);
                        self.$data.isRequestLoading = false;
                        self.$data.error = error;
                    });
                }).catch(function(err){
                    // console.log(`Error on image uploading...`);
                    self.$data.isRequestLoading = false;
                    self.$data.error = err;
                });
            },
            delete_avatar: function (event) {
                event.preventDefault();
                this.$data.isRequestLoading = true;

                this.$apollo.mutate({
                    mutation: DELETE_AVATAR,
                    variables: {}
                }).then(() => {
                    // console.log(`Avatar successfully deleted`);
                    this.deleteUserAvatarStore();
                    this.$data.isRequestLoading = false;
                }).catch((error) => {
                    // console.error(`Error ${error} on avatar deleting`);
                    this.$data.error = errorMessageDisplay(error);
                    this.$data.isRequestLoading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>